/* Surface Gaming skin customizer — EDIT FROM CART.
   Loads third, after sg-cust-model.js and sg-customizer.js.

   The cart's Edit link carries the LINE KEY, not the design: ?edit=<key>.
   The line already holds SubModel, one property per part, and a variant id
   that encodes the add-ons, so the whole configuration is read back out of
   /cart.js. A stale or foreign key degrades silently to a normal visit.

   Updating REPLACES the original line. Add first, remove second: if the add
   fails the original is still in the cart, and a plain POST is left to show
   Shopify's real error.

   THE NO-CHANGE CASE. Shopify merges a line when the variant AND every
   line-item property match, returning the EXISTING line key. So pressing
   Update without changing anything used to: merge (quantity 1 -> 2), then
   delete that key — and the item vanished. The merge is therefore the exact
   signal for "nothing changed": when /cart/add.js hands back the key we were
   editing, restore the original quantity instead of deleting. Shopify's own
   equality test does the comparing, so there is no second implementation of
   "is this the same design" to drift.

   TWO THINGS A CART LINE CAN CARRY THAT NO LONGER MATCH THE DEVICE
   ---------------------------------------------------------------
   1. An OLD part key. Lines written before the vocabulary was standardised
      say "Side" where the G502 now says Left_Side, "body" where the G Pro
      Wireless now says Top. The old key is almost always the filename token,
      so the part's `file` list doubles as its alias list — no second table.
   2. A material the device no longer offers (a cart line with Glacial Frost
      on a G502, which now excludes it). That part is deliberately NOT
      restored — the store stopped selling it — and the banner says so rather
      than quietly showing "None" and letting the shopper wonder.
*/
(function(){
  "use strict";
  var V = window.SG_VIEW, M = window.SG_MODEL;
  if(!V || !M) return;
  var KEY = M.editKey();
  if(!KEY) return;

  var state = V.state, PARTS = M.PARTS, SUBS = M.SUBS, TOKENS = M.TOKENS;
  var byCode = M.byCode, BLANK = M.BLANK;
  var ORIG_QTY = 1;
  var BASE_MSG = "Editing an item in your cart — updating replaces it.";

  function bail(){ KEY = ""; V.cancelEdit(); }

  fetch("/cart.js", { headers: { Accept: "application/json" } })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      var line = null;
      for(var i = 0; i < cart.items.length; i++){
        if(cart.items[i].key === KEY) line = cart.items[i];
      }
      var addons = line ? M.addonsOfVariant(line.variant_id) : null;
      if(!line || addons === null){ bail(); return; }

      var props = line.properties || {};
      /* case-insensitive, so "body" finds a property written "Body" */
      var idx = {};
      Object.keys(props).forEach(function(k){ idx[k.toLowerCase()] = props[k]; });

      /* every distinct value this part could be stored under: its own key
         first, then each filename token (which is what the old key was) */
      function valuesFor(p){
        var out = [];
        [p.key].concat(p.file || []).forEach(function(n){
          var v = idx[String(n).toLowerCase()];
          if(v !== undefined && v !== "" && out.indexOf(v) === -1) out.push(v);
        });
        return out;
      }

      if(props.SubModel && SUBS.indexOf(props.SubModel) > -1) state.sub = props.SubModel;

      var dropped = [], merged = [];
      PARTS.forEach(function(p){
        var vals = valuesFor(p);
        if(!vals.length) return;
        /* a merged part (Sides) may find two different old values */
        if(vals.length > 1) merged.push(p.label);
        var val = vals[0];
        if(val === "-"){ if(BLANK) state.picks[p.key] = BLANK; return; }
        var c = M.codeByName(val);
        if(c && byCode[c]){ state.picks[p.key] = c; return; }
        dropped.push(p.label + " (" + val + ")");
      });

      TOKENS.forEach(function(t){ state.addons[t] = addons.indexOf(t) > -1; });

      ORIG_QTY = line.quantity || 1;
      var q = V.form.querySelector('input[name="quantity"]');
      if(q) q.value = ORIG_QTY;

      var msg = BASE_MSG;
      if(dropped.length){
        msg += " " + dropped.join(", ") + (dropped.length > 1 ? " are" : " is") +
               " no longer available on this model — please choose again.";
      }
      if(merged.length){
        msg += " " + merged.join(", ") + " now take a single colour.";
      }
      V.note.textContent = msg;
      if(dropped.length) V.note.className = "sg-editnote is-warn";

      V.touch();
      V.note.hidden = false;
      V.renderAll();
    })
    .catch(bail);

  V.form.addEventListener("submit", function(e){
    if(!KEY) return;
    e.preventDefault();
    var btn = document.getElementById("sgAdd");
    btn.disabled = true;
    fetch("/cart/add.js", { method: "POST", body: new FormData(V.form),
                            headers: { Accept: "application/json" } })
      .then(function(r){ return r.json(); })
      .then(function(added){
        if(added.status){ KEY = ""; btn.disabled = false; V.form.submit(); return null; }
        /* merged back into the line we were editing => nothing changed, so put
           the quantity back rather than deleting the item */
        var same = added.key === KEY;
        return fetch("/cart/change.js", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: KEY, quantity: same ? ORIG_QTY : 0 })
        }).then(function(){ window.location.href = "/cart"; });
      })
      .catch(function(){ window.location.href = "/cart"; });
  });
})();